/* eslint jsx-a11y/click-events-have-key-events: 0,jsx-a11y/no-static-element-interactions: 0 */
import React from 'react';

import LargeModal from '@goeuro/app/client/frontend-components/src/Modals/LargeModal';
import { Tick2 } from '@goeuro/app/client/frontend-components/src/Icons2/Tick2';
import { Back } from '@goeuro/app/client/frontend-components/src/Icons2/Back';

import { colorBrandPrimary300 } from 'constants/colors';
import { MobileHeaderMenuProps } from './MobileHeader.props';
import * as Styled from './MobileHeaderMenu.styled';

const MenuModal = ({
  title,
  showModal,
  toggle,
  options,
  onChange,
}: MobileHeaderMenuProps) => (
  <LargeModal
    visible={showModal}
    header={
      <Styled.Header>
        <Styled.IconButton onClick={toggle}>
          <Back width={24} height={24} color={colorBrandPrimary300} />
        </Styled.IconButton>
        <Styled.HeaderTitle>{title}</Styled.HeaderTitle>
      </Styled.Header>
    }
    onClose={toggle}
    fullWidth
  >
    <Styled.OptionsWrapper>
      {options.map(option => (
        <Styled.OptionContainer
          key={option.key}
          onClick={() => onChange(option.key)}
        >
          <Styled.OptionLabelWrapper>
            <Styled.OptionSelectedIcon selected={option.selected}>
              <Tick2 width={24} height={24} />
            </Styled.OptionSelectedIcon>
            <Styled.OptionLabel selected={option.selected}>
              {option.label}
            </Styled.OptionLabel>
          </Styled.OptionLabelWrapper>
          {option.iconSrc && (
            <div style={{ marginRight: '8px' }}>
              <img src={option.iconSrc || ''} width={24} alt={option.label} />
            </div>
          )}
          {option.symbol && (
            <Styled.OptionLabel symbol>{option.symbol}</Styled.OptionLabel>
          )}
        </Styled.OptionContainer>
      ))}
    </Styled.OptionsWrapper>
  </LargeModal>
);

export default MenuModal;
